import { apiClient } from '@shopuptech/ui-core';
import env from '../variables';

export const fetch = apiClient({
  baseUrl: window.location.origin,
  appEnv: env.appEnv,
});
